import React, { Dispatch, SetStateAction } from 'react';
import { useStyles } from 'features/subscription/components/Plans/style';
import CustomCard from 'features/subscription/components/Plans/Cards';
import { useSelector } from 'store';

type AllPlanProps = {
  subscriptionButtonDisabled: boolean;
  setSubscriptionButtonDisabled: Dispatch<SetStateAction<boolean>>;
  currency: string;
};

export const AllPlans: React.FC<AllPlanProps> = ({
  subscriptionButtonDisabled,
  setSubscriptionButtonDisabled,
  currency,
}) => {
  const classes = useStyles();
  const { selectedPlans, isLoading, allSubscriptionData } = useSelector(state => state?.subscriptionReducer);

  return (
    <div className={classes.root}>
      {isLoading ? (
        <>
          <p>Loading...</p>
        </>
      ) : (
        <>
          {allSubscriptionData?.length &&
            allSubscriptionData?.map(value => (
              <CustomCard
                value={value}
                defaultSelected={selectedPlans}
                currency={currency}
                subscriptionButtonDisabled={subscriptionButtonDisabled}
                setSubscriptionButtonDisabled={setSubscriptionButtonDisabled}
                key={value.id}
              />
            ))}
        </>
      )}
    </div>
  );
};
